import React from 'react';
import Image from 'components/image';
import PropTypes from 'prop-types';
import cn from 'classnames';

const DescriptionList = ({ items }) =>
  items && items.length > 0 ? (
    <dl className="description-list">
      {items.map((item, index) => (
        <div
          key={index}
          className={cn('description-list__item', {
            'description-list__item--with-image': item.image
          })}
        >
          <div className="description-list__item-key">
            {item.image && (
              <div className="description-list__item-image-holder">
                <Image
                  {...item.image}
                  responsive={false}
                  className="description-list__item-image"
                />
              </div>
            )}
            <dt className="description-list__item-tag">{item.tag}</dt>
          </div>

          <dd className="description-list__item-description">
            {item.description}
          </dd>
        </div>
      ))}
    </dl>
  ) : null;

DescriptionList.propTypesMeta = 'exclude';

DescriptionList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.exact({
      tag: PropTypes.string,
      description: PropTypes.string,
      image: PropTypes.exact(Image.propTypes)
    })
  )
};

export default DescriptionList;
